import DesignRegistry from './DesignRegistry.container';

export default DesignRegistry;
